/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function(_) {
  var ns = nspace("ccc.indicatorSelection");

  ns.IndicatorSelectionRouter = Backbone.Router.extend({
    initialize: function() {
      _.bindAll(this, "updateUrl");
    },

    routes: {
      "": "initializeViews",
      ":currentTab": "initializeViews",
      ":currentTab/:selectedCategories": "initializeViews"
    },

    initializeViews: function(currentTab, selectedCategories) {
      // This method will only ever be invoked a single time, so use
      // it to initialize the model/view classes and trigger the initial rendering
      this.model = new ns.IndicatorSelectionModel();
      if (typeof currentTab !== "undefined") {
        // Find the ID matching the specified tab name
        // NOTE: It's not ideal to interact directly with the DOM here in the router, but it IS expedient.
        var currentTabId = $(
          ".location-type-link[data-slug='" + currentTab + "']"
        ).data("id");

        this.model.set({
		currentTab: currentTab,
		currentTabId: currentTabId,
		silent: true
	});

      }

      if (typeof selectedCategories !== "undefined") {
        var catIds = selectedCategories.split(",");
        var catIdHash = {};
        for (var i = 0; i < catIds.length; i++) {
          catIdHash[parseInt(catIds[i], 10)] = true;
        }
        this.model.set("selectedCategories", catIdHash, {
          silent: true
        });
      }

      // Listen for changes to the model and update our URL
      this.model.on("change", this.updateUrl);

      // Apply the model to the views
      this.selectorsView = new ns.IndicatorSelectionButtonsView({
        model: this.model
      });
      this.tableView = new ns.IndicatorSelectionTreeView({
        model: this.model
      });

      // Trigger a change notification on the model now that all of the selectors have finished initializing
      // so that other components can update themselves to reflect the current app state
      this.model.trigger("change");
    },

    updateUrl: function() {
      var urlParts = [this.model.get("currentTab")];

      var cats = this.model.get("selectedCategories");
      if (cats && _.size(cats) > 0) {
        urlParts.push(_.keys(cats).join(","));
      }

      this.navigate(urlParts.join("/"), { replace: true });
    }
  });
})(_);
